// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3q5aK","type":"styles_type__26kkw","choices":"styles_choices__iO4g-"};